/**
 * CarouselTab
 * 
 * @Author: Focci
 * @Date: 2023-08-07 13:51:05
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-07 13:51:05
 */

'use client'

import PropTypes from 'prop-types'
import SVGPicture from '@img/picture.svg'
import SVGFloorPlans from '@img/floor-plans.svg'
import SVGPlay from '@img/play-circle.svg'
import SVGBox from '@img/box.svg'
import SVGMap from '@img/map-locale.svg'
import SVGStreetView from '@img/street-view.svg'
import Container from '@comp/Container'
import TabWithIcon from '@comp/TabWithIcon'
import { useTranslations } from 'next-intl'
import { useMemo } from 'react'
import { getInitImages } from './lib'

function getBarOptions(init, house, th) {
  const { images, floorPlan, video, threeDView, allImages, vrThumbnail } = init
  const res = [
    { 
      label: th('picture'),
      value: 'img',
      icon: <SVGPicture width="1rem" />,
      badge: images.length,
      disabled: images.length === 0
    },
    {
      label: th('floorPlans'),
      value: 'floor_plan',
      icon: <SVGFloorPlans width="1rem" />,
      index: allImages.indexOf(floorPlan[0]),
      badge: floorPlan.length,
      disabled: floorPlan.length === 0
    },
    {
      label: th('video'),
      value: 'video',
      index: allImages.indexOf(video),
      icon: <SVGPlay width="1rem" />,
      disabled: !video
    },
    {
      label: th('vrProperty'),
      value: 'three-d-view',
      index: allImages.indexOf(vrThumbnail),
      icon: <SVGBox width="1rem" />,
      disabled: !threeDView
    },
    {
      label: th('map'),
      value: 'map',
      icon: <SVGMap width="1rem" />,
      disabled: !(house.lng && house.lat)
    },
  ]

  if(house.publishAddress) {
    res.push({
      label: th('streetView'),
      value: 'street-view',
      icon: <SVGStreetView />,
      disabled: !(house.lng && house.lat)
    })
  }

  return res
}

export default function PropertyCarouseTab({
  house = {},
  onChange = () => {}
}) {
  const th = useTranslations('house')
  const options = useMemo(
    () => getBarOptions(getInitImages(house, th), house, th), 
    [house, th]
  )
  
  return (
    <div className="absolute -bottom-5 left-0 right-0 z-30">
      <Container className="w-274">
        <div className="flex">
          <TabWithIcon 
            options={options} 
            onChange={onChange}
            showDisabled={false}
          />
        </div>
      </Container>
    </div>
  )
}

PropertyCarouseTab.propTypes = {
  house: PropTypes.object,
  onChange: PropTypes.func,
}
